import soundFile from '../../assets/audio/notification.wav';

/**
 * Conversation limit ("modo cola") — alert sound when a conversation takes a
 * seat. Browsers block programmatic audio until the user interacts with the
 * page (autoplay policy), so `initSeatSound` arms playback on the first
 * pointerdown/keydown and `playSeatSound` is a no-op until then. Never throws.
 */

const STORAGE_KEY = 'iv_conversation_limit_sound_enabled';

let initialized = false;
let armed = false;
let audio = null;

export const isSeatSoundEnabled = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'false';
  } catch (e) {
    return true;
  }
};

export const setSeatSoundEnabled = (enabled) => {
  try {
    localStorage.setItem(STORAGE_KEY, enabled === true ? 'true' : 'false');
  } catch (e) {
    // Storage unavailable (private mode / quota): the toggle just won't persist.
  }
};

const arm = () => {
  armed = true;
  window.removeEventListener('pointerdown', arm);
  window.removeEventListener('keydown', arm);
};

/** Idempotent; call when the chat mounts. */
export const initSeatSound = () => {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;
  window.addEventListener('pointerdown', arm, { once: true });
  window.addEventListener('keydown', arm, { once: true });
};

export const playSeatSound = () => {
  try {
    if (!armed || !isSeatSoundEnabled()) return;
    if (!audio) audio = new Audio(soundFile);
    const playPromise = audio.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(() => {
        // Autoplay rejection or decode error: an alert must never break the chat.
      });
    }
  } catch (e) {
    // Audio unsupported: skip silently.
  }
};
